import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-slate-950 pt-16 pb-8 border-t border-slate-900" data-id="element-280">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-281">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-282">
          {/* Brand Column */}
          <div className="lg:col-span-1" data-id="element-283">
            <a href="#" className="text-2xl font-extrabold text-white tracking-tight mb-4 block" data-id="element-284">
              FindService<span className="text-amber-500" data-id="element-285">Quotes</span>
            </a>
            <p className="text-slate-400 leading-relaxed" data-id="element-286">
              Connecting homeowners with trusted local professionals since 2019.
            </p>
          </div>

          {/* Services Column */}
          <div data-id="element-287">
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4" data-id="element-288">
              Services
            </h3>
            <ul className="space-y-3" data-id="element-289">
              {['Walk-In Showers', 'Walk-In Tubs', 'Window Replacement', 'Roofing', 'Siding', 'Solar Panels', 'Bathroom Remodel', 'Kitchen Remodel', 'Flooring', 'HVAC', 'Plumbing', 'Electrical'].map(item => <li key={item} data-id="element-290">
                  <a href="#" className="text-slate-400 hover:text-white transition-colors" data-id="element-291">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Company Column */}
          <div data-id="element-292">
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4" data-id="element-293">
              Company
            </h3>
            <ul className="space-y-3" data-id="element-294">
              {['About Us', 'How It Works', 'For Professionals', 'Blog', 'Careers'].map(item => <li key={item} data-id="element-295">
                  <a href="#" className="text-slate-400 hover:text-white transition-colors" data-id="element-296">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Support Column */}
          <div data-id="element-297">
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4" data-id="element-298">
              Support
            </h3>
            <ul className="space-y-3" data-id="element-299">
              {['Help Center', 'Contact Us', 'Privacy Policy', 'Terms of Service'].map(item => <li key={item} data-id="element-300">
                  <a href="#" className="text-slate-400 hover:text-white transition-colors" data-id="element-301">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-302">
          <p className="text-slate-500 text-sm text-center md:text-left" data-id="element-303">
            &copy; {currentYear} FindServiceQuotes. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}